import {Notification} from "../../API";

import {updateNotification as updateNotificationGQL} from "../../graphql/mutations";
import {queryGqlApi} from "../../graphql/queryGqlApi";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";


export type NotificationChangeAllowedFields = Pick<Notification, 'status'>

export const updateNotificationDB = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    notification: Notification,
    fieldsToUpdate: NotificationChangeAllowedFields
) => {
    return queryGqlApi(
        updateNotificationGQL,
        {
            input: {
                id: notification.id,
                _version: notification._version,
                ...{
                    ...fieldsToUpdate,
                },
            }
        },
        dataClientService,
        authService,
        'main'
    )
}


export const setNotificationStatus = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    notification: Notification, newStatus: string) => {
    return updateNotificationDB(dataClientService, authService, notification, {
        status: newStatus,
    });
}

export const hideNotification = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    notification: Notification) => {
    return updateNotificationDB(dataClientService, authService, notification, {
        status: 'deleted',
    });
}